"use client";

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import getViewportHideStyles from "../../Hide/helpers/getViewportHideStyles";
const StyledColumn = styled.div.withConfig({
  displayName: "LayoutColumn__StyledColumn",
  componentId: "sc-aa57pk-0"
})(["", ""], ({
  spanEntireRow,
  hideOn
}) => css(["", ";", ";"], !!hideOn && getViewportHideStyles(hideOn), spanEntireRow && css(["grid-column:1 / -1;"])));
StyledColumn.defaultProps = {
  theme: defaultTheme
};
const LayoutColumn = ({
  children,
  hideOn,
  as = "div",
  spanEntireRow,
  dataTest
}) => {
  return (
    /*#__PURE__*/
    // @ts-expect-error TODO
    React.createElement(StyledColumn, {
      "data-test": dataTest,
      hideOn: hideOn,
      as: as,
      spanEntireRow: spanEntireRow
    }, children)
  );
};
export default LayoutColumn;